import type React from 'react';
import type { TypographyVariants, TypographyWeight } from '../Typography';
import type { IconComponentType } from '../../types';
import type { CreateSlotsAndSlotProps, SlotProps } from '../../slots/types';

export type StepTitleProps = {
  label: string;
  className?: string;
  variant?: TypographyVariants;
  weight?: TypographyWeight;
};

export type StepDescriptionProps = {
  description: string;
  className?: string;
  variant?: TypographyVariants;
  weight?: TypographyWeight;
};

export type Step<T = string> = {
  value: T;
  label?: string;
  description?: string;
  Icon?: IconComponentType;
  subSteps?: Omit<Step, 'subSteps'>[];
  /**
   * @deprecated do not use this prop, should be standardized across the app after design system is updated
   */
  className?: string;
} & CreateSlotsAndSlotProps<
  { label?: React.ElementType; description?: React.ElementType },
  {
    label: SlotProps<React.ElementType, object, object>;
    description: SlotProps<React.ElementType, object, object>;
  }
>;

export type StepDetails = {
  showCompleteIndicator?: boolean;
  clickable?: boolean;
  orientation?: 'horizontal' | 'vertical';
  showStepNumber?: boolean;
  label?: {
    weight?: TypographyWeight;
    variant?: TypographyVariants;
  };
  description?: {
    weight?: TypographyWeight;
    variant?: TypographyVariants;
  };
};

export type StepperProps = {
  steps: Step[];
  orientation?: 'horizontal' | 'vertical';
  style?: React.CSSProperties;
  className?: string;
  stepDescriptionClassName?: string;
  stepLabelClassName?: string;
  /**
   * @deprecated do not use this prop, should be standardized across the app after design system is updated
   */
  substepContainerClassName?: string;
  size?: 'sm' | 'md' | 'lg';
  /**
   * @deprecated do not use this prop, should be standardized across the app after design system is updated
   */
  stepGap?: number;
  controlledState?: {
    activeStepId: string;
    onStepChange: (activeStepId: string) => void;
  };
  stepDetails?: StepDetails;
};

export enum StepStatus {
  Pending = 'pending',
  Active = 'active',
  Completed = 'completed',
}
